var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 21,
    viewBox: "0 0 15 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_back_arrow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7158 1.70282L14.7158 19.2972C14.7158 19.8475 14.4205 20.322 13.9258 20.5663C13.4312 20.8107 12.8736 20.7575 12.4344 20.4241L0.844279 11.627C0.488315 11.3568 0.284159 10.946 0.284159 10.5C0.284159 10.054 0.488316 9.64322 0.844279 9.37303L12.4344 0.575861C12.8736 0.242462 13.4312 0.1893 13.9259 0.433651C14.4205 0.678001 14.7158 1.15246 14.7158 1.70282Z",
    fill: "#306FDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.568316 10.5C0.568316 10.8568 0.731639 11.1854 1.01641 11.4016L12.6065 20.1988C12.9579 20.4655 13.404 20.508 13.7997 20.3125C14.1954 20.117 14.4317 19.7375 14.4317 19.2972L14.4317 1.70282C14.4317 1.26253 14.1954 0.882963 13.7997 0.687485C13.404 0.492008 12.9579 0.534534 12.6065 0.801254L1.01641 9.59843C0.731639 9.81457 0.568316 10.1432 0.568316 10.5ZM9.17939e-07 10.5C9.62186e-07 9.99388 0.224049 9.48776 0.672142 9.14764L12.2622 0.350466C13.3846 -0.501433 15 0.296513 15 1.70282L15 19.2972C15 20.7035 13.3846 21.5014 12.2622 20.6495L0.672142 11.8524C0.224048 11.5122 8.73693e-07 11.0061 9.17939e-07 10.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_back_arrow",
    x: 0,
    y: 0,
    width: 16,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_back_arrow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_back_arrow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.1c036705638be66ec002736013028776.svg";
export { ForwardRef as ReactComponent };